(function ($) {
  'use strict';

  const mapElement = document.getElementById('tx_mwstationfinder_map');
  const searchPanel = document.getElementsByClassName('c-fixed-panel__search')[0];
  const searchResultPanel = document.getElementsByClassName('c-fixed-panel__search__result')[0];
  const detailPanel = document.getElementsByClassName('c-fixed-panel__detail')[0];
  const searchForm = document.getElementsByClassName('c-map-form')[0];
  const termField = document.querySelectorAll('[name="tx_mwstationfinder_stationfinder[q]"]')[0];
  const distanceField = document.querySelectorAll('[name="tx_mwstationfinder_stationfinder[d]"]')[0];
  const breadCrumbLength = document.getElementsByClassName('navigation-breadcrumb__anchor').length;
  const currentBreadcrumLink = document.getElementsByClassName('navigation-breadcrumb__anchor--current')[0];
  let M = null;

  let stationfinder = {
    initialize: function () {
      if (mapElement && 'undefined' !== typeof L) {
        let options = {
          initialCenter: [51.4677, 10.23926],	// the intial center point
          initialZoom: 8,						// the initial zoom level
          restrictBounds: new L.LatLngBounds(
            new L.LatLng(41.8040, -17.2705),
            new L.LatLng(59.4450, 37.7709)
          ),
          tilesUrl: mapSettings.tilesUrl,
          tilesMaxZoom: mapSettings.tilesMaxZoom,
          tilesMinZoom: mapSettings.tilesMinZoom
        };

        // Create the map (M)
        M = L.map('tx_mwstationfinder_map', {
          maxBounds: options.restrictBounds,
          animate: true,
          attributionControl: false,
          zoomControl: false
        }).setView(
          options.initialCenter,
          options.initialZoom
        );

        // Create Control in bottom right corner
        new L.Control.Zoom({position: 'bottomright'}).addTo(M);

        // Create the layer for the maptiles
        L.tileLayer(options.tilesUrl, {
          maxZoom: options.tilesMaxZoom,
          minZoom: options.tilesMinZoom
        }).addTo(M);

        // Create markers from json data.
        // geoJson variable is filled in fluid template and has to keep a special format
        let geoJsonLayer = L.geoJSON(geoJson, {
          pointToLayer: function (geoJsonPoint, latlng) {
            return L.marker(
              latlng,
              {
                icon: L.divIcon(
                  {
                    className: 'marker',
                    iconSize: [mapSettings.markerWidth, mapSettings.markerHeight],
                    html: `<div id="marker_${geoJsonPoint.id}" class="c-marker__inner-default${(geoJsonPoint.properties.virtual === true) ? ' c-marker__inner-default--grey' : ''}">${mapSettings.markerSvg}</div>`
                  }
                )
              }
            );
          },
          onEachFeature: function (feature, layer) {
            // Bind tooltip to markers
            layer.bindTooltip(
              feature.properties.name,
              {
                direction: 'top',
                offset: [0, -15],
                opacity: 1
              }
            );
            // Bind onclick to markers
            layer.on('click', function (e) {
              Array.from(document.getElementsByClassName('c-marker__inner-active')).forEach((activeMarker) => {
                activeMarker.classList.remove('c-marker__inner-active');
              });
              document.getElementById('marker_' + e.sourceTarget.feature.properties.id).classList.add('c-marker__inner-active');

              M.setView(
                e.latlng,
                options.tilesMaxZoom
              );

              stationfinder.openDetailPanel(e.sourceTarget.feature.properties.detailUrl);
            });
          }
        });

        // Add markers to map
        M.addLayer(geoJsonLayer);

        searchForm.onsubmit = function (e) {
          e.preventDefault();

          stationfinder.performSearch();
        };

        currentBreadcrumLink.onclick = function (e) {
          e.preventDefault();

          stationfinder.closeDetailView();
        }
      }
    },
    openDetailPanel: function(detailUrl) {
      let xhr = new XMLHttpRequest();

      let url = new URL(stationfinder.removeTrailingSlashFromUrl(detailUrl));
      url.searchParams.set('type', mapSettings.ajaxPageType);

      xhr.open('GET', url);
      xhr.send();

      stationfinder.resetBreadcrumb();

      searchPanel.style.display = "none";
      searchResultPanel.style.display = "none";
      detailPanel.style.display = "block";
      detailPanel.innerHTML = '';

      xhr.onload = function() {
        detailPanel.innerHTML = xhr.response;

        let oldHeadline = document.getElementsByClassName('c-map-detail__headline')[0],
            newheadline = document.createElement('h3');

        newheadline.classList.add('c-map-detail__headline');
        newheadline.textContent = oldHeadline.textContent;
        oldHeadline.parentNode.prepend(newheadline);
        oldHeadline.parentNode.removeChild(oldHeadline);

        Array.from(document.getElementsByClassName('c-map__back')).forEach((backLink) => {
          backLink.onclick = function (e) {
            e.preventDefault();

            stationfinder.closeDetailView();
          };
        });

        document.getElementsByClassName('navigation-breadcrumb__anchor--current')[0]
          .classList.remove('navigation-breadcrumb__anchor--current')

        let breadcrumbItem = document.createElement('li');
        breadcrumbItem.classList.add('o-list-inline__item');

        let breadcrumbLink = document.createElement('span');
        breadcrumbLink.classList.add('navigation-breadcrumb__anchor');
        breadcrumbLink.classList.add('navigation-breadcrumb__anchor--current');
        breadcrumbLink.textContent = newheadline.textContent;

        breadcrumbItem.append(breadcrumbLink);
        document.getElementsByClassName('c-breadcrumb-list')[0].append(breadcrumbItem);
        stationfinder.updateBreadcrumb();
      };
    },
    performSearch: function() {
      searchResultPanel.innerHTML = '';

      if (termField.value !== '') {
        let xhr = new XMLHttpRequest();
        let url = new URL(stationfinder.removeTrailingSlashFromUrl(searchForm.getAttribute('action')));

        url.searchParams.set('type', mapSettings.ajaxPageType);
        url.searchParams.set('tx_mwstationfinder_stationfinder[q]', termField.value);
        url.searchParams.set('tx_mwstationfinder_stationfinder[d]', distanceField.value);

        xhr.open('GET', url);
        xhr.send();

        xhr.onload = function() {
          searchResultPanel.innerHTML = xhr.response;
          stationfinder.bindPageBrowserLinks();
          stationfinder.bindResultListLinks();
        }
      }
    },
    // remove trailing / so ?type can be added to url
    removeTrailingSlashFromUrl: function(url) {
      if (url.endsWith('/')) {
        url = url.substring(0, url.length - 1);
      }
      return url;
    },
    bindPageBrowserLinks: function() {
      Array.from(document.querySelectorAll('.c-map-result-pagination a')).forEach((pageBrowserLink) => {
        pageBrowserLink.onclick = function (e) {
          e.preventDefault();

          document.getElementsByClassName('c-map-result-list')[0].innerHTML = '';
          document.getElementsByClassName('c-map-result-pagination')[0].innerHTML = '';

          let xhr = new XMLHttpRequest();
          let pagebrowserUrl = new URL(pageBrowserLink.getAttribute('href'));

          xhr.open('GET', pagebrowserUrl);
          xhr.send();

          xhr.onload = function() {
            searchResultPanel.innerHTML = xhr.response;
            stationfinder.bindPageBrowserLinks();
            stationfinder.bindResultListLinks();
          }
        }
      });
    },
    bindResultListLinks: function() {
      Array.from(document.getElementsByClassName('c-map-result-list__link')).forEach((resultLink) => {
        resultLink.onclick = function (e) {
          e.preventDefault();

          Array.from(document.getElementsByClassName('c-marker__inner-active')).forEach((activeMarker) => {
            activeMarker.classList.remove('c-marker__inner-active');
          });
          document.getElementById('marker_' + resultLink.getAttribute('data-uid'))
            .classList.add('c-marker__inner-active')

          stationfinder.openDetailPanel(resultLink.getAttribute('data-detail-url'));

          M.setView(
            [
              resultLink.getAttribute('data-latitude'),
              resultLink.getAttribute('data-longitude')
            ],
            mapSettings.tilesMaxZoom
          );
        }
      });
    },
    closeDetailView: function() {
      detailPanel.style.display = "none";
      searchPanel.style.display = "block";
      searchResultPanel.style.display = "block";
      Array.from(document.getElementsByClassName('c-marker__inner-active')).forEach((activeMarker) => {
        activeMarker.classList.remove('c-marker__inner-active');
      });

      stationfinder.resetBreadcrumb();
    },
    updateBreadcrumb: function() {
      let breadcrumb = document.querySelectorAll('.navigation-breadcrumb__anchor');
      let anchor = document.createElement('a');
      anchor.classList.add('navigation-breadcrumb__anchor');
      anchor.innerText = document.querySelector('[data-page-title]').getAttribute('data-page-title');
      anchor.href = document.querySelector('[data-page-slug]').getAttribute('data-page-slug');
      breadcrumb[1].parentElement.replaceChild(anchor, breadcrumb[1]);
    },
    resetBreadcrumb: function() {
      if (document.getElementsByClassName('navigation-breadcrumb__anchor').length > breadCrumbLength) {
        let currentAnchor = document.getElementsByClassName('navigation-breadcrumb__anchor--current')[0];
        currentAnchor.parentNode.previousElementSibling.getElementsByTagName('a')[0]
          .classList.add('navigation-breadcrumb__anchor--current');
        currentAnchor.parentNode.parentNode.removeChild(currentAnchor.parentNode);
      }
    }
  };

  stationfinder.initialize();
})();
